import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';
import zxcvbn from 'zxcvbn';

const PasswordStrengthMeter = ({ password }) => {
  const strength = password ? zxcvbn(password).score : 0;
  
  const getStrengthColor = (score) => {
    switch (score) {
      case 0:
        return '#f44336'; // Red
      case 1:
        return '#ff9800'; // Orange
      case 2:
        return '#ffc107'; // Yellow
      case 3:
        return '#4caf50'; // Green
      case 4:
        return '#2196f3'; // Blue
      default:
        return '#e0e0e0'; // Grey
    }
  };

  const getStrengthText = (score) => {
    switch (score) {
      case 0:
        return 'Sehr schwach';
      case 1:
        return 'Schwach';
      case 2:
        return 'Mittel';
      case 3:
        return 'Gut';
      case 4:
        return 'Stark';
      default:
        return '';
    }
  };

  return (
    <Box sx={{ width: '100%', mt: 1 }}>
      <LinearProgress
        variant="determinate"
        value={(strength + 1) * 20}
        sx={{
          height: 8,
          borderRadius: 4,
          backgroundColor: '#e0e0e0',
          '& .MuiLinearProgress-bar': {
            backgroundColor: getStrengthColor(strength),
          },
        }}
      />
      <Typography
        variant="caption"
        sx={{
          display: 'block',
          mt: 1,
          color: getStrengthColor(strength),
          fontWeight: 'bold',
        }}
      >
        {password ? getStrengthText(strength) : 'Passwortstärke'}
      </Typography>
    </Box>
  );
};

export default PasswordStrengthMeter; 